"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectProp = void 0;
const util_1 = require("../util");
/**
 * Allows any object. No further runtime validation is performed by default.
 *
 * Type parameter `T` can be used to restrict the type at compile time.
 *
 * @param validator - Optional function for further runtime validation; should return `undefined` if valid, or an error string if invalid.
 */
const objectProp = (validator) => (0, util_1.propOptionsGenerator)(Object, validator);
exports.objectProp = objectProp;
